export const CODE_API = {
   SUCCESS: 200
}

export const APP_CODE_LOGGER = 'MOCHA_WEB'
